import React from 'react';
import { Link } from 'react-router-dom';
import { APP_VERSION, DEVELOPER } from './utils/constants';

export default function About() {
  return (
    <div className="block-center">
      <h1>关于</h1>
      <Link to="/" className="big">
        返回主页
      </Link>

      <p className="no-margin">生物节律曲线 {APP_VERSION}</p>
      <p>开发者 {DEVELOPER}</p>

      <h2>介绍</h2>

      <div className="intro">
        <p>
          人体生物三节律，因为这三个节律就象钟表一样循环往复，又被人们称作“人体生物钟”，简称“PSI”周期说。
          “PSI”是英文Physical(体力),Sensitive(情绪),Intellectual(智力)的缩写。
        </p>
        <p>
          人体生物节律可分为高潮期、低潮期和临界日。
          高潮期是能量释放阶段，低潮期是能量蓄积补充阶段。
          在每一个运转周期中，总是由高潮转向低潮，再由低潮转向高潮。
          高潮期、低潮期相互过渡的交替日子，被称为临界日。
        </p>

        <h3>体力节律</h3>
        <p>
          高潮期：体力充沛，身体灵活，动作敏捷，耐力和爆发力强，充满活力，能担负较大负荷的体力劳动，劳累后恢复得快；此时身体抗病能力强，不易感染疾病，治疗疾病效果明显。
        </p>
        <p>
          临界日：抵抗力低，免疫功能差，身体软弱无力，极易疲劳。易受外来各种不良因素的侵袭。有时表现的动作失常。运动员进行大运动量训练易受伤。慢性病极易复发或病情加重，是危重病人或老人的危险点。多数人往往死于临界日。
        </p>
        <p>
          低潮期：身体乏力、懒散，耐力和爆发力较差，劳动时常感到力不从心，易疲劳。比较容易感染疾病，特别是哮喘病极易发作。低潮期治病的效果一般不明显。
        </p>

        <h3>情绪节律</h3>
        <p>
          高潮期：心情愉快，舒畅乐观，精力充沛，意志坚强，办事有信心，创造力、艺术感染力强。是创作的最好时期。思路灵活、敏捷，是解决矛盾，处理疑难问题的好时候。对待问题的态度积极且富建设性。能与人融洽相处。经商贸易一般不易出错，效率也高。
        </p>
        <p>
          临界日：情绪不稳定，烦躁易怒，心绪不宁，精力特别不易集中。精神恍惚，工作易出差错，最易出交通、航空飞行和工伤事故。自制能力差，缺乏理智、容易冲动。一点小事都可能激怒人，人一旦被激怒常做出过火行为。是精神病、冠心病的发病期和危险期。自杀多发生在该阶段。有无事生非心态，做不好调解工作。一些矛盾激化事件如打架斗殴、家庭邻里纠纷也多在此时发生。
        </p>
        <p>
          低潮期：情绪低落，精神不振，意志比较消沉。做事缺乏勇气，信心不足，注意力易分散，常感到烦躁不安或心绪不宁，此时也容易出工作差错和事故。
        </p>

        <h3>智力节律</h3>
        <p>
          高潮期：头脑灵活，思维敏捷，思路清晰，记忆力强，精力和注意力集中。善于综合分析，判断准确，逻辑思维性强，工作效率和工作质量高。是学习、创造、写文章、决策、计算的最佳时机。
        </p>
        <p>
          临界日：判断力差、健忘、注意力涣散，严重者头脑发晕发胀，丢三忘四，工作中极易出差错和失误。此时不宜做计算、交易，最好也不强迫自己写文章。
        </p>
        <p>
          低潮期：思维显得迟钝，记忆力较弱。理解和构思联想比较缓慢，逻辑思维能力较弱，注意力不易集中，判断力往往降低，缺乏直觉、工作详细效率不高。
        </p>
      </div>
    </div>
  );
}
